import React from 'react';
import { Accordion, TableComponent } from '../../../../../../components';
import { AccordionStyle } from '../../../../../../constants';
import { ArrowDown } from '../../../../../../assets';
import { useTealium } from '../../../../../../tealium/useTealium';
import { formatCurrency } from '../../../../../../helpers';
import styles from '../Withdrawal.module.css';
import PropTypes from 'prop-types';

const RepaymentHeader = {
  displayDate: 'Date',
  capital: 'Capital',
  cost: 'Cost',
  repayment: 'Repayment Amount'
};

export const RepaymentScheduleAccordion = ({ open, toggle, amtToWithdrawResp, isMobile }) => {
  const { track, events } = useTealium();
  return(
    <Accordion
      isOpen={open === 'repaymentSchedule'}
      containerStyle={isMobile ? { borderRadius: 19 } : { borderRadius: 8 }}
      headerChildren={
        <>
          <div style={AccordionStyle.accordionHeaderLeft}>
            <div className={styles.withdrawlAccordionTitle}>Expected repayment schedule</div>
          </div>
          <img
            style={{ ...AccordionStyle.ArrowImg, rotate: open === 'repaymentSchedule' ? '180deg' : '' }}
            src={ArrowDown}
            alt='DropdownOpen'
            role='presentation'
            onClick={() => {track(events.creditFacility.toggleAccordian('fundingDetails', open === 'fundingDetails' ? 'collapse': 'expand')); toggle(open === 'repaymentSchedule' ? '' : 'repaymentSchedule');}}
          />
        </>
      }
    >
      <div className={styles.accordion}>
        <ul className={styles.repaymentDetailsList}>
          <li>The repayment schedule for your most recent drawdown will be cancelled and replaced by the repayment schedule below.</li>
          <li>Repayment of your funding is made {amtToWithdrawResp?.paymentFrequency} via a debit order over {amtToWithdrawResp?.termLength} ({amtToWithdrawResp?.repaymentSchedule?.length} payments in total)</li>
          <li>Please note that we do not charge any processing, initiating or monthly service fees. We only charge the cost as per below, simple!</li>
          <li>A debit order on your previous advance has already been submitted for processing by your bank or has already been debited from your account. Therefore, the capital portion of this debit order has already been factored into your current available balance.</li>
        </ul>

        {Array.isArray(amtToWithdrawResp?.repaymentSchedule) && (
          <TableComponent
            data={amtToWithdrawResp.repaymentSchedule.map(d => ({
              ...d,
              capital: formatCurrency(d.capital),
              cost: formatCurrency(d.cost),
              repayment: formatCurrency(d.repayment)
            }))}
            heading={RepaymentHeader}
          />
        )}
      </div>
    </Accordion>
  );
};
RepaymentScheduleAccordion.propTypes = {
  open: PropTypes.string.isRequired,
  toggle: PropTypes.func.isRequired,
  amtToWithdrawResp:PropTypes.string,
  isMobile: PropTypes.bool.isRequired
};